<script lang="ts" setup>
import PrivacyPolicy from "./policies/privacy-policy.md";
import TermsOfService from "./policies/terms-of-service.md";
import YongHuXieYi from "./policies/yong-hu-xie-yi.md";
import XuFeiXieYi from "./policies/xu-fei-xie-yi.md";
import YinSiZhengCe from "./policies/yin-si-zheng-ce.md";
import CommunityGuidelines from "./policies/community-guidlines.md";
import ContentRemovalPolicy from "./policies/content-removal-policy.md";
import ComplaintsPolicy from "./policies/complaints-policy.md";
import LPC from "./policies/LPC.md";
import { nextTick, ref, watch } from "vue";

const props = defineProps<{
  show: boolean;
  docType: string;
}>();

const emit = defineEmits<{
  (e: "update:show", value: boolean): void;
}>();

const contentRef = ref<HTMLDivElement>();

watch(
  () => props.show,
  (v) => {
    if (v) {
      nextTick(() => {
        if (contentRef.value) {
          contentRef.value.scrollTop = 0;
        }
      });
    }
  }
);
</script>

<template>
  <VanPopup
    :show="show"
    @update:show="emit('update:show', $event)"
    position="bottom"
    closeable
    zIndex="3000"
    teleport="body"
    class="h-[100%]"
  >
    <div class="h-full w-full overflow-hidden flex flex-col">
      <div ref="contentRef" class="p-4 overflow-y-auto w-full">
        <div class="w-full prose prose-sm lg:prose-base overflow-hidden">
          <PrivacyPolicy v-if="docType === 'privacy-policy'" />
          <TermsOfService v-if="docType === 'terms-of-service'" />
          <CommunityGuidelines v-if="docType === 'community-guidelines'" />
          <ContentRemovalPolicy v-if="docType === 'content-removal-policy'" />
          <ComplaintsPolicy v-if="docType === 'complaints-policy'" />
          <YongHuXieYi v-if="docType === 'user-agreement-cn'" />
          <YinSiZhengCe
            v-if="docType === 'privacy-policy-cn'"
            class="break-all"
          />
          <LPC v-if="docType === 'lpc'" />
          <XuFeiXieYi v-if="docType === 'xu-fei-xie-yi'" />
        </div>
      </div>
    </div>
  </VanPopup>
</template>
